import { useMemo, useState } from "react";

import { groupTodosByDate, TodoGroup, TodoGroupLabels } from "./helpers";
import { TodoItemData } from "./item";

export type DateFilter = "all" | "today" | "week" | "absence";
export type TypeFilter = "all" | "CALL" | "MEETING" | "INTERNAL_TASK";
export type PriorityFilter = "all" | "urgent" | "important";

export const useTodoFilters = (todos: TodoItemData[], todoGroupLabels: TodoGroupLabels) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState<DateFilter>("today");
  const [typeFilter, setTypeFilter] = useState<TypeFilter>("all");
  const [priorityFilter, setPriorityFilter] = useState<PriorityFilter>("all");
  const [archiveFilter, setArchiveFilter] = useState(false);

  // Grupisanje po datumu - backend je već filtrirao podatke
  const groupedTodos: TodoGroup[] = useMemo(
    () => groupTodosByDate(todos, todoGroupLabels),
    [todos, todoGroupLabels],
  );

  return {
    // Filter states
    searchQuery,
    setSearchQuery,
    dateFilter,
    setDateFilter,
    typeFilter,
    setTypeFilter,
    priorityFilter,
    setPriorityFilter,
    archiveFilter,
    setArchiveFilter,
    // Computed values
    groupedTodos,
  };
};
